import { Store } from 'redux';
import configureStoreDev from './configureStore.dev';
import configureStoreProd from './configureStore.prod';

let store: Store<unknown> | null = null;

export default function configureStore(initialState?: any) {
    if (!store) {
        let { env } = window.appConfig;
        store =
            env === 'production'
                ? configureStoreProd(initialState)
                : configureStoreDev(initialState);
    }
    return store;
}
